import Event from '../../core/Event';
import Customer from '../../../domain/Customer';

export default class CustomersReceived extends Event {
    public static type = 'CustomersReceived';

    constructor(public readonly customers: Customer[]) {
        super(CustomersReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/CustomersReceived.ts